import React from 'react';
import { useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Joi from 'joi';
import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import {Organization} from "../../../classes/Organization";
import {Mission} from "../../../classes/Mission";

function TaskMissionOrganizationLayout(props: {
    title: string,
    initInfo: Mission,
    organizationList?: Organization[],
    onSubmit: Function,
    onCancel: Function
}) {

    const [isPendingSubmit, setPendingSubmit] = useState<boolean>(false);
    const [inputOrganizationId, setInputOrganizationId] = useState<number | undefined>(props.initInfo.assignedOrganizationId);
    
    const isOrganizationIdValid = Joi.number().integer().positive().required().validate(inputOrganizationId);
    const isValid = (!isOrganizationIdValid.error);

    function handleSubmit() {
        setPendingSubmit(true);
        props.onSubmit(inputOrganizationId);
    }

    const bottomControls = isPendingSubmit === true ? (<Typography>Loading...</Typography>) : [(<Button variant='text' onClick={() => props.onCancel()}>Cancel</Button>), (<Button variant='contained' disabled={!isValid} onClick={handleSubmit}>Submit</Button>)];

    if (props.organizationList === undefined || props.organizationList === null) {
        return (<Typography variant="h6">Loading...</Typography>)
    }

    return (
        <Stack direction="column" spacing={1}>
            <Typography variant="h6">{props.title}</Typography>
            <FormControl fullWidth disabled={isPendingSubmit}>
                <InputLabel id="organization-select">Select Organization</InputLabel>
                <Select
                    labelId="organization-select"
                    label="Select Organization"
                    disabled={isPendingSubmit}
                    value={inputOrganizationId}
                    onChange={(event: any) => setInputOrganizationId(event.target.value)}
                >
                    <MenuItem value={undefined}>none</MenuItem>
                    {props.organizationList.map((p) => (<MenuItem value={p.id}>{p.name}</MenuItem>))}
                </Select>
            </FormControl>
            <Stack direction="row" spacing={1} justifyContent="right">{bottomControls}</Stack>
        </Stack>
    );
}

export default TaskMissionOrganizationLayout;